import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_295: DocMigration = {
  maxSchemaVersion: "0.0.295",
  description: "Add finer grained controls for roof dimensions.",
  apply(json: any): any {
    for (const dormerId in json.dormers) {
      const dormer = json.dormers[dormerId];

      if (dormer.hideVerticalDimensions !== undefined) {
        dormer.dormerElevationPlanSettings = { showDormerWindowVerticalDimensions: !dormer.hideVerticalDimensions };
        delete dormer.hideVerticalDimensions;
      }

      // simply renaming prop
      if (dormer.roofPlanSettings !== undefined) {
        dormer.dormerPlanSettings = dormer.roofPlanSettings;
        delete dormer.roofPlanSettings;
      }
    }

    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];
      if (roof.dimensionsOnElevations && !roof.disableAnnotations) {
        roof.roofElevationPlanSettings = {
          showDormerWallFramingWidthDimensions: true,
          showDormerWallFramingHeightDimensions: true,
          showRoofHorizontalPlacementDims: true,
          showDormerHorizontalPlacementDims: true,
          showRoofWidthDims: true,
          showDormerRoofWidthDims: true,
        };
      }

      delete roof.dimensionsOnElevations;

      if (roof.disableAnnotations) {
        setRoofSettingProp(roof, "roofPlanSettings", "includeRoofSlopeAnnotation", false);
        setRoofSettingProp(roof, "roofPlanSettings", "includeRoofOverhangDimensions", false);
        setRoofSettingProp(roof, "roofElevationPlanSettings", "showRoofSlopeElevationAnnotation", false);
        setRoofSettingProp(roof, "roofElevationPlanSettings", "showRoofTruncationHeightDims", false);
      }

      delete roof.disableAnnotations;
    }

    return json;
  },
};

function setRoofSettingProp(roof: any, settingObjName: string, settingPropName: string, val: boolean) {
  if (!roof[settingObjName]) {
    roof[settingObjName] = { [settingPropName]: val };
  } else {
    roof[settingObjName][settingPropName] = val;
  }
}

export default migration_0_0_295;
